import { render, staticRenderFns } from "./ShowDiff.vue?vue&type=template&id=7c21525c&scoped=true"
import script from "./ShowDiff.vue?vue&type=script&lang=js"
export * from "./ShowDiff.vue?vue&type=script&lang=js"
import style0 from "./ShowDiff.vue?vue&type=style&index=0&id=7c21525c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21525c",
  null
  
)

export default component.exports